module.exports = __webpack_public_path__ + "static/img/reset-on-64px.f078001f.png";